export default __webpack_public_path__ + "static/media/osmosis-scientist.221bb139.png";